import { Table } from "react-bootstrap";

const DraftGraphViewGraphSummary = ({ draftGraphSummary}) => { 
  return(
    <div className="p-3 shadow-sm bg-light rounded">
      <p className="fs-2">Draft Graph Summary</p>
      <Table>
        <thead>
          <tr>
            <th>
              Type
            </th>
            <th>
              Percentage
            </th>
            <th>
              Views
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              1 Day
            </td>
            <td>
              {draftGraphSummary.oneDayPercent.toFixed(2)}%
            </td>
            <td>
              {draftGraphSummary.oneDayViews}
            </td>
          </tr>
          <tr>
            <td>
              2 Day
            </td>
            <td>
              {draftGraphSummary.twoDayPercent.toFixed(2)}%
            </td>
            <td>
              {draftGraphSummary.twoDayViews}
            </td>
          </tr>
          <tr>
            <td>
              More Than 2 Days
            </td>
            <td>
              {draftGraphSummary.greaterThanTwoDayPercent.toFixed(2)}%
            </td>
            <td>
              {draftGraphSummary.greaterThanTwoDayViews}
            </td>
          </tr>
          <tr>
            <td>
              Total
            </td>
            <td></td>
            <td>
              {draftGraphSummary.totalViews}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}

export default DraftGraphViewGraphSummary;